import { TabRouteType } from '@dfl/react-security';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { SettingsIcon, UserIcon } from 'components/SvgIcons';
import { TabLabel } from 'modules/common/components/TabLabel';

export const clientDetailsTabs: TabRouteType[] = [
  {
    path: '/client/:id/general',
    to: '/general',
    label: 'tabs.general',
    render: () => <TabLabel Icon={SettingsIcon} label={'tabs.general'} ns={'client'} />,
  },
  {
    path: '/client/:id/structure',
    to: '/structure',
    label: 'tabs.establishment',
    render: () => <TabLabel Icon={ArticleOutlinedIcon} label={'tabs.establishment'} ns={'client'} />,
  },
  {
    path: '/client/:id/users',
    to: '/users',
    label: 'tabs.users',
    permissions: ['USER_ADMIN'],
    render: () => <TabLabel Icon={UserIcon} label={'tabs.users'} ns={'client'} />,
  },
];
